import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'

type BreakdownBarChartProps = {
  data: { name: string; count: number }[]
  color?: string
  tooltipFormatter?: (value: number) => string
}

const BreakdownBarChart: React.FC<BreakdownBarChartProps> = ({
  data,
  color = '#0d6efd',
  tooltipFormatter,
}) => (
  <ResponsiveContainer width="100%" height={Math.max(data.length * 36, 60)}>
    <BarChart
      data={data}
      layout="vertical"
      margin={{ top: 4, right: 24, bottom: 4, left: 4 }}
    >
      <XAxis type="number" allowDecimals={false} hide />
      <YAxis
        type="category"
        dataKey="name"
        width={140}
        tick={{ fontSize: 12 }}
      />
      <Tooltip
        formatter={
          tooltipFormatter
            ? (value: number) => [tooltipFormatter(value), '']
            : undefined
        }
      />
      <Bar dataKey="count" fill={color} radius={[0, 4, 4, 0]} barSize={16} />
    </BarChart>
  </ResponsiveContainer>
)

export default BreakdownBarChart
